import { Controller } from '@hotwired/stimulus';

import CurrentPage from '@frontend/app/features/CurrentPage';
import {
  apply as queryParamsApply,
  extract as extractQueryParams,
} from '@frontend/utils/query-params';

export default class extends Controller {
  static targets = ['player', 'playButton'];
  static values = {
    srcUrl: String,
    audioIsAttached: Boolean,
  };

  connect() {
    if (!this.hasPlayerTarget || !this.audioIsAttachedValue) return;

    if (CurrentPage.getShareUrl().isActive) {
      const shareUrl = CurrentPage.getShareUrl().url;
      const newSrcUrl = queryParamsApply(
        this.srcUrlValue,
        extractQueryParams(shareUrl)
      );
      this.srcUrlValue = newSrcUrl;
      this.setServingViaShareUrl(true);
    } else {
      this.setServingViaShareUrl(false);
    }

    this.playerTarget.src = this.srcUrlValue;
  }

  setServingViaShareUrl(bool) {
    this.playerTarget.dataset.testAudioPlayerIsServingViaShareUrl = bool;
  }
}
